import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from "react";

// text-base (16px) : évite le zoom automatique de Safari iOS sur les champs.
const base =
  "w-full rounded-lg border border-stone-200 px-3 py-2.5 text-base focus:border-stone-400 focus:outline-none";

export function Input({ className = "", ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`${base} ${className}`} />;
}

export function Textarea({ className = "", ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={`${base} ${className}`} />;
}

export function Field({
  label,
  error,
  children,
}: {
  label: string;
  error?: string;
  children: ReactNode;
}) {
  return (
    <label className="flex flex-1 flex-col gap-1 text-sm">
      <span className="text-stone-600">{label}</span>
      {children}
      {error && <span className="text-xs text-rose-600">{error}</span>}
    </label>
  );
}
